var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      class: _vm.customClass,
      attrs: { role: "group", "aria-labelledby": _vm.labelId },
    },
    _vm._l(_vm.options, function (option, index) {
      return _c("li", { key: "key-" + option, staticClass: "option" }, [
        _c(
          "button",
          {
            staticClass: "enhancements-card-button",
            class: { selected: _vm.selectedOption === option },
            attrs: {
              type: "button",
              role: "button",
              "aria-pressed": _vm.selectedOption === option ? "true" : "false",
            },
            on: {
              click: function ($event) {
                return _vm.selectOption(option)
              },
            },
          },
          [
            _c("div", { staticClass: "enhancements-card-button-container" }, [
              _vm.showIcon ? _c("span", { class: _vm.iconClass }) : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "label-text" }, [
                _vm._v(_vm._s(option)),
              ]),
              _vm._v(" "),
              _vm.selectedOption === option
                ? _c("span", { staticClass: "icon-checkmark-gold" })
                : _vm._e(),
            ]),
          ]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }